import { useLayoutEffect, type ReactNode } from "react";

/**
 * Removes the head script's `data-boot-hide` mark on the app's first commit
 * (ADR-WBC1): by then React has replaced whatever #root held before the
 * bundle ran, so there is nothing stale left to hide. It is the first child,
 * so its layout effect runs before any effect or ref of the app itself: the
 * app never measures a #root that is still display: none, and the commit is
 * painted with #root shown.
 */
export function BootReveal({ children }: { children: ReactNode }) {
  return (
    <>
      <RevealRoot />
      {children}
    </>
  );
}

function RevealRoot() {
  useLayoutEffect(() => {
    document.documentElement.removeAttribute("data-boot-hide");
  }, []);
  return null;
}
